<!-- eslint-disable prettier/prettier -->
<template>
    <fragment name="designer-services-page-container">
        <div class="row">
            <div class="column small-12 medium-3">
              <profile-strength
                :percentage="models.profileStrength.percentage"
                class="mbm"
              />
              <manage-account-menu :menu="models.menu" />
            </div>
            <div class="column small-12 medium-9">
              <DesignerServicesTable
                  :designer-services="currentPage"
                  :api-base-url="pagination.apiBaseUrl"
                  :urls="models.urls"
                />
                <Pagination
                  class="mtm"
                  :max-page="pagination.maxPage"
                  :current="pagination.current"
                  :start="pagination.start"
                  :end="pagination.end"
                  :start-of-page="pagination.startOfPage"
                  :number-of-results="pagination.numberOfResults"
                  :total-results-count="pagination.totalResultsCount"
                  :description="pagination.description"
                  :base-url="pagination.baseUrl"
                  :api-base-url="pagination.apiBaseUrl"
                  :left-arrow-icon-url="icons.paginationLeftArrow"
                  :right-arrow-icon-url="icons.paginationRightArrow"
                  :api-post-object="apiPostObject"
                  @page-link-click="onPaginationClick"
                />
            </div>
        </div>
    </fragment>
  </template>

<script>
import DesignerServicesTable from '../../components/my-account/designer/designer-services/DesignerServicesTable.vue';
import ManageAccountMenu from '../../components/my-account/ManageAccountMenu/ManageAccountMenu.vue';
import ProfileStrength from '../../components/my-account/designer/overview/ProfileStrength/ProfileStrength.vue';
import Pagination from '../../components/shared/PaginationV2/PaginationV2.vue';

export default {
  components: {
    ManageAccountMenu,
    ProfileStrength,
    Pagination,
    DesignerServicesTable,
  },
  props: {
    models: {
      type: Object,
      required: true,
    },
    icons: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      apiPostObject: {
        page: 1,
        status: null,
        sortBy: null,
      },
      currentPage: this.models.services,
      pagination: this.models.pagination,
    };
  },
  methods: {
    onPaginationClick(e) {
      this.currentPage = e.items;
      this.pagination = e.pagination;
    },
  },
};
</script>
